// ANCHOR React
import React from 'react';

// ANCHOR Model
import createModel from '@lxsmnsyc/react-scoped-model';

type ContentFilter = 'Live Seminars' | 'Courses';
type SetState<T> = React.Dispatch<React.SetStateAction<T>>;

interface IState {
  handler: {
    filter: SetState<ContentFilter>;
    eventSearch: SetState<string>
    courseSearch: SetState<string>
  };
  state: {
    filter: ContentFilter;
    eventSearch: string;
    courseSearch: string;
  };
  check: {
    seminar: boolean;
    course: boolean;
  };
}

export const ProviderContentFilter = createModel<IState>(() => {
  const [filter, setFilter] = React.useState<ContentFilter>('Courses');
  const [eventSearch, setEventSearch] = React.useState<string>('');
  const [courseSearch, setCourseSearch] = React.useState<string>('');

  return {
    handler: {
      filter: setFilter,
      eventSearch: setEventSearch,
      courseSearch: setCourseSearch,
    },
    state: {
      filter,
      eventSearch,
      courseSearch,
    },
    check: {
      seminar: filter === 'Live Seminars',
      course: filter === 'Courses',
    },
  };
});
